import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Modal, Button, Table } from 'antd'
// import {DropOption} from '../../../components'

 
const { confirm } = Modal

const modalDelete = (modalDeleteProps) => {
 
   
  const { modalVisible, handleCancel , info, deleteTraining} = modalDeleteProps 
  return (

    <Modal
      title="Delete Training"
      visible={modalVisible}  
      onCancel={handleCancel}
      footer={[
        <Button onClick={handleCancel}>Close</Button> , 
        <Button type="info" onClick={() => deleteTraining()} >OK</Button> 
      ]}
    >
      <p>{`Are you sure you want to delete this training?`}</p>
      {/* {Object.keys(info.credentials || {})
        .filter(key => info.credentials[key])
        .map(key => {
            return (
                <div className="pad-btm">
                    <strong className="text-main">{key}</strong>
                    <br/>
                    {info.credentials[key]}
                </div>
            );
        })} */}
    
    </Modal> 
  ) 
}

export default modalDelete
